import { mergePresetColumns } from "utils/MergePresetColumns";
import { productStandardList } from "./productStandardList";
import { productQoList } from "./productQoList";
import { productSoList } from "./productSoList";
import { productDoList } from "./productDoList";
import { productInvoiceList } from "./productInvoiceList";
import { productReceiptList } from "./productReceiptList";
import { docStandardList } from "./docStandardList";
export var columnPresets = {
    standard: productStandardList,
    qo: mergePresetColumns(productStandardList, productQoList),
    so: mergePresetColumns(productStandardList, productSoList),
    do: mergePresetColumns(productStandardList, productDoList),
    invoice: mergePresetColumns(productStandardList, productInvoiceList),
    receipt: mergePresetColumns(productStandardList, productReceiptList),
    docStandard: docStandardList
};
